/** @format */

import styled from 'styled-components';

export const MutiLineEllipsisWrapper = styled.div`
	display: -webkit-box;
	word-break: break-all;
	overflow: hidden;
	-webkit-line-clamp: ${(props) => props.line};
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	${(props) => props.width && `width: ${props.width}px;`}
`;

export const InlineEllipsisWrapper = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	${(props) => props.width && `width: ${props.width}px;`}
`;
